export const debounce = ( cb, timeout = 500 ) => {
  let interval;

  return ( ...args ) => {
    let self = this;
    let debounced = function() {
      interval = null;
      cb.apply( self, args );
    };

    clearTimeout( interval );
    interval = setTimeout( debounced, timeout );
  };
};